import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	colors,
} from '@mui/material';

import { UploadFile } from 'actions';
import ModalDialog from '../../../../../../components/ModalDialog/ModalDialog.js';
import AddTicketForm from './components/AddTicketForm/AddTicketForm.js';

import { GetActivities, SetFormState, AddTicket } from '../../../../actions/TicketsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const AddTicketDialog = (props) => {
	const { open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const user = useSelector((state) => state.session.user);
	const teams = useSelector((state) => state.ticketsReducer.teams);
	const activities = useSelector((state) => state.ticketsReducer.activities);
	const types = useSelector((state) => state.ticketsReducer.types);
	const formState = useSelector((state) => state.ticketsReducer.formState);

	const _onConfirmClick = () => {
		setFormState({ ...formState, values: { ...formState.values, submit: true } });
		if (formState.isValid) {
			const newTicket = { ...formState.values, userId: user.id };
			newTicket.comments = [];
			newTicket.attachedFiles = [];
			newTicket.comments.push({ comment: newTicket.comment });
			if (formState.values.selectedFile) {
				UploadFile(formState.values.selectedFile).then(response => {
					newTicket.attachedFiles.push({ fileName: response.data });
					dispatch(AddTicket(newTicket));
					onClose();
				});
			} else {
				dispatch(AddTicket(newTicket));
				onClose();
			}
		}
	};

	const getData = useCallback(() => {
		dispatch(GetActivities(1));
	}, []);

	useEffect(() => {
		getData();
	}, []);

	return (
		<ModalDialog
			maxWidth="md"
			onClose={onClose}
			open={open}
			title="Add ticket"
			confirmLabel="Save"
			onConfirmClicked={_onConfirmClick}
		>
			<AddTicketForm types={types} teams={teams} activities={activities} />
		</ModalDialog>
	);
};

AddTicketDialog.propTypes = {
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default AddTicketDialog;
